import { ReactNode } from "react";
import { Card, CardContent, CardHeader } from "@/shared/ui/card";

interface AuthCardProps {
  children: ReactNode;
  className?: string;
}

export function AuthCard({ children, className = "" }: AuthCardProps) {
  return (
    <Card className={`w-full max-w-md bg-[#1E1E1E] border-white/[0.06] rounded-lg shadow-sm ${className}`}>
      {children}
    </Card>
  );
}

interface AuthCardHeaderProps {
  children: ReactNode;
  className?: string;
}

export function AuthCardHeader({ children, className = "" }: AuthCardHeaderProps) {
  return (
    <CardHeader className={`space-y-1 ${className}`}>
      {children}
    </CardHeader>
  );
}

interface AuthCardContentProps {
  children: ReactNode;
  className?: string;
}

export function AuthCardContent({ children, className = "" }: AuthCardContentProps) {
  return (
    <CardContent className={className}>
      {children}
    </CardContent>
  );
}
